import Vue from 'vue'
import { mapState } from 'vuex'
import { JobOfferStages } from '@/constants/job/jobOfferStages'
import rolebleMixin from '@/mixins/rolebleMixin'
import snackMixin from '@/mixins/snackMixin'
import {
  applicationManageMixin,
  disputableMixin,
  doneJobManageMixin,
  jobPartiesMixin,
  offerManageMixin,
  payableMixin,
  refundableMixin,
  reportableMixin,
  reviewableMixin,
  startableMixin,
  statusesMixin,
} from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [
    applicationManageMixin,
    disputableMixin,
    doneJobManageMixin,
    jobPartiesMixin,
    offerManageMixin,
    payableMixin,
    rolebleMixin,
    snackMixin,
    refundableMixin,
    reportableMixin,
    reviewableMixin,
    startableMixin,
    statusesMixin,
  ],
  data() {
    return {
      canceling: false,
    }
  },
  computed: {
    ...mapState({
      application: (state: any) => state.jobChat.application.value,
    }),
    hasAcceptOffer() {
      return this.application?.offer?.stage === JobOfferStages.NEW
    },
  },
  methods: {
    onPayToTalentClick() {
      this.payToTalent()
    },
    onRefundClick() {
      this.refundToCustomer()
    },
    onStartJobClick() {
      this.startJob()
    },
    onCreateDisputeClick() {
      this.createDispute()
    },
    onLeaveReviewClick() {
      this.leaveReview()
    },
    onSendOfferClick() {
      this.sendOffer()
    },
    async onCancelOfferClick() {
      try {
        this.canceling = true
        await this.cancelOffer()
      } finally {
        this.canceling = false
      }
    },
    async onAcceptOfferClick() {
      this.acceptOffer()
    },
    onDeclineApplicationClick() {
      this.declineApplicationByCustomer()
    },
    onRetractApplicationClick() {
      this.declineApplicationByFreelancer()
    },
    onDoneClick() {
      this.markJobAsDone()
    },
    onCancelJobDoneClick() {
      this.markJobAsNotDone()
    },
    onReportClick() {
      this.reportUser()
    },
    onRemoveFromArchiveClick() {
      this.setArchivedMeta(false)
    },
  },
})
